import { RootState } from "store/store";
import { StreamState } from "./StreamTypes";
// Stream selectors
export const getIsStreaming = (state: RootState): StreamState['isStreaming'] => state.stream.isStreaming;
export const getIsStartVolume = (state: RootState): StreamState['isStartVolume'] => state.stream.isStartVolume;
export const getIsOverlayVisible = (state: RootState): StreamState['isOverlayVisible'] => state.stream.isOverlayVisible;
export const getIsClicked = (state: RootState): StreamState['isClicked'] => state.stream.isClicked;
